import { Stack } from "expo-router";

/**
 * The Manager portal was collapsed into a reduced-permission Client (a
 * "limited client"). Nothing renders here anymore — the two child routes
 * (`index` and the `[...rest]` catch-all) immediately redirect `/manager/*`
 * to the equivalent `/client/*` path so stale bookmarks and old deep links
 * still land somewhere useful. No shell, no PortalGate: the destination
 * /client routes do their own gating.
 */
export default function ManagerRedirectLayout() {
  return <Stack screenOptions={{ headerShown: false, animation: "none" }} />;
}
